import i18n from 'i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

import translationEn from './locales/en.translation';
import translationEs from './locales/es.translation';

i18n.use(LanguageDetector).init({
    debug: false,
    defaultNS: 'translations',
    fallbackLng: 'en',
    interpolation: {
        escapeValue: false,
        formatSeparator: ','
    },
    keySeparator: false,
    ns: ['translations'],
    // nsSeparator: false will remove that detection of namespaces in keys passed in t function, and will allow strings with colons, like URLs
    nsSeparator: false,
    react: {
        useSuspense: true
    },
    resources: {
        en: { translations: translationEn },
        es: { translations: translationEs }
    }
});

export default i18n;
